<template>
  <Page :title="title">
    <div class="header">
      <div class="logo">
        <img :src="require('@/assets/img/logo.png')" alt="" />
      </div>
      <div class="survey-title">
        <span>{{ survey.name }}</span>
      </div>
    </div>
    <div class="content">
      <div
        v-for="(problem, index) in survey.problems"
        :key="problem.id"
        class="problem"
      >
        <div class="problem-name">
          <span>{{ index + 1 + "/" + survey.problems.length + "." }}</span>
          <span>{{ problem.name }}</span>
        </div>
        <div class="options">
          <div
            v-for="option in problem.options"
            :key="option.id"
            class="option"
          >
            <span>
              {{ option.name }}
            </span>
            <span v-if="option.optionContent">
              {{ option.optionContent }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="footer flex">
      <div class="primary item1" @click="exit">退出</div>
    </div>
  </Page>
</template>
<script lang="js">
  export default {
      comments:{},
      data(){
          return {
              title: '问卷调查',
              surveyId: '',
              custId:'',
              groupCode:'',
              survey: {
                name: '',
                problems: []
              }
          }
      },
      created(){
        let surveyId = this.$route.query.surveyId;
        let custId = this.$route.query.custId;
        let groupCode = this.$route.query.groupCode;
        if (surveyId && custId) {
            this.surveyId = surveyId;
            this.custId = custId;
            this.groupCode = groupCode;
            this.viewSurvey(surveyId, custId, groupCode);
        }
      },
      mounted(){
  
      },
      methods: {
        async viewSurvey(surveyId, custId, groupCode){
            try {
                let response = await this.$api.viewSurvey({
                    surveyId: surveyId,
                    custId: custId,
                    groupCode: groupCode,
                })
                if(response.fail || !response.data ||response.data.length === 0){
                    this.$title("查询问卷信息失败")
                }
                
                response.data.forEach(d => {
                    this.survey.name = d.name;
                    let index = this.survey.problems.findIndex(p => p.id === d.pid)
                    if(index < 0){
                       let problem ={
                        name: d.pName,
                        id: d.pid,
                        type: d.type,
                        options: [{
                            name: d.oName,
                            id: d.oid,
                            optionContent: d.option_content,
                        }]                        
                       }
                       this.survey.problems.push(problem)
                    }else{
                        let option = {                            
                            name: d.oName,
                            id: d.oid,
                            optionContent: d.option_content,
                        }
                        this.survey.problems[index].options.push(option)
                    }                
                });
            } catch (error) {
                console.log(error)
                this.$title("查询问卷信息失败")
            }
           
        },
        exit(){
            this.$router.push({
                path: "/ClientDetails",
                query: {
                    custId: this.custId,
                    IdCode: 12,
                    showCC: this.$store.state.show==1||localStorage.getItem('show')==1
                },
            })
        },
      }
  }
</script>    
<style scoped lang="less" rel="stylesheet/less">
.logo {
  img {
    width: 1rem;
    height: 1rem;
    margin: 2px;
  }
}
.survey-title {
  display: flex;
  justify-content: center;
  font-size: 18px;
  padding-bottom: 1rem;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-bottom-color: #525252;
  margin: 0 0.5rem;
}
.content {
  margin: 0.4rem 0.5rem 0.5rem;
  max-height: calc(100vh - 2.6rem - 70px);
  overflow: auto;
}
.problem {
  font-size: 18px;
  margin-bottom: 0.4rem;
}
.options {
  font-size: 16px;
}
.option {
  margin-left: 0.4rem;
}
.footer {
  height: 46px;
  line-height: 46px;
  text-align: center;
  font-size: 15px;
  color: #fff;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 5;
}
.primary {
  background-color: #e10913;
}
</style>
  


// WEBPACK FOOTER //
// src/components/client/childCompoents/viewSurvey.vue